(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("01gMz", function(module, exports) {
"use strict";
const $003d1cc23fadae7a$var$videosSections = document.querySelectorAll(".s-videos");
$003d1cc23fadae7a$var$videosSections.forEach((section)=>{
    const loadMoreButton = section.querySelector(".s-videos__button .btn");
    const loadMoreButtonWrapper = section.querySelector(".s-videos__button");
    const videosGroup = section.querySelector(".g-videos__list");
    const moreVideosGroup = section.querySelector(".g-videos-more");
    let clicked = false;
    if (!loadMoreButton || !loadMoreButtonWrapper || !videosGroup || !moreVideosGroup) return;
    const videosGroupItems = videosGroup.querySelectorAll(".g-videos__item");
    window.addEventListener("resize", ()=>{
        if (clicked) {
            if (window.matchMedia("screen and (max-width: 1299px)").matches) {
                videosGroupItems.forEach((item)=>{
                    item.style.setProperty("display", "flex");
                });
                moreVideosGroup.classList.add("--hidden");
            } else {
                videosGroupItems.forEach((item, index)=>{
                    if (index > 2) item.style.setProperty("display", "none");
                });
                moreVideosGroup.classList.remove("--hidden");
            }
        }
    });
    loadMoreButton.addEventListener("click", ()=>{
        clicked = true;
        if (window.matchMedia("screen and (max-width: 1299px)").matches) {
            videosGroupItems.forEach((item)=>{
                item.style.setProperty("display", "flex");
            });
            moreVideosGroup.classList.add("--hidden");
        } else moreVideosGroup.classList.remove("--hidden");
        loadMoreButtonWrapper.classList.add("--hidden");
    });
});

});

})();
//# sourceMappingURL=videos-more-group.1b4e8244.js.map
